// client/src/api/apiClient.js
import apiClient, { resetCsrf } from "../utils/http";

let interceptorAttached = false;

export { resetCsrf };

export const attachAuthInterceptor = ({ store, clearAuth }) => {
  if (interceptorAttached) return;
  interceptorAttached = true;

  apiClient.interceptors.response.use(
    (res) => res,
    (err) => {
      if (err?.response?.status === 401 && err?.config?.__authFinalFail) {
        store.dispatch(clearAuth());
      }
      return Promise.reject(err);
    },
  );
};

export default apiClient;
